import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import { VocabularyPictureCardModel } from "@/models/vocabulary-list.model";
import { post } from "superagent";

class VocabularyPictureCardServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsvpc" };

	constructor() {
		super();
		this.getVCSVocabularyPictureCards = this.getVCSVocabularyPictureCards.bind(this);
	}

	getVCSVocabularyPictureCards(levelIds?: number[]): Promise<VocabularyPictureCardModel[]> {
		return this.get("vocabularypicturecard", { levelIds: levelIds });
	}

	saveVCSVocabularyPictureCards(levelId: number, vpcs: string[]) {
		return this.create("{levelId}/savevocabularypicturecard", vpcs, { levelId: levelId });
	}
}

export const VocabularyPictureCardService = new VocabularyPictureCardServiceClass();
